export default {
  columns: (vm) => {
    let group = true
    let del = true
    let edit = true
    return [{
        title: '集团编号',
        key: 'GroupCode',
        resizable: true,
        minWidth: 160,
        sortable: true,
        align: 'center'
      },{
        title: '公司编号',
        key: 'CompanyCode',
        resizable: true,
        minWidth: 160,
        sortable: true,
        align: 'center'
      },{
        title: '部门编号',
        key: 'DepartmentCode',
        resizable: true,
        minWidth: 160,
        sortable: true,
        align: 'center'
      },
      {
        title: '部门名称',
        key: 'DepartmentName',
        resizable: true,
        minWidth: 160,
        sortable: true,
        align: 'center'
      },
      {
        title: '创建人员',
        key: 'CreateUser',
        resizable: true,
        sortable: true,
        minWidth: 160,
        align: 'center' 
      },
      {
        title: '创建日期',
        key: 'CreateDate',
        resizable: true,
        sortable: true,
        minWidth: 190,
        align: 'center'
      },
      {
        title: '操作',
        align: 'center',
        width: 276,
        render: (h, params) => {
          let newArray = [];
          if (edit) newArray.push(
            h('Button', {
              props: {
                type: 'primary',
                size: 'small'
              },
              style: {
                marginRight: '5px'
              },
              on: {
                click: () => {
                  vm.paymentClick(params.row, params.index);
                }
              }
            }, '编辑')
          )
          if (del) newArray.push(
            h('Button', {
              props: {
                type: 'error',
                size: 'small'
              },
              style: {
                marginRight: '5px'
              },
              on: {
                click: () => {
                  vm.deleteClick(params.row, params.index)
                }
              }
            }, '删除')
          )
          return h('div', newArray);
        }
      },
    ]
  }
}
